import React, { useState } from 'react';
import Datatable from '../../components/Datatable';
import moment from 'moment';

export default function LogAudit() {
    const [refresh, setRefresh] = useState(false)

    React.useEffect(() => {
        document.title = "IPV7 Hermes - Logs de Auditoria"
    }, [])

    return (
        <Datatable
            refresh={refresh}
            handlerRefresh={() => setRefresh(!refresh)}
            title='Logs de Auditoria'
            endpoint='/hermes/audit'
            options={{
                customToolbarSelect: () => ""
            }}
            columns={[
                {
                    name: 'id',
                    label: "ID",
                    options: {
                        filter: false,
                        sort: false,
                        display: false
                    }
                },
                {
                    name: "username",
                    label: 'Usuário',
                },
                {
                    name: "message",
                    label: 'Mensagem',
                },
                {
                    name: "created_at",
                    label: "Data",
                    options: {
                        customBodyRender: value => (
                            <span>{moment(value).locale('pt-br').format('DD/MM/YYYY HH:mm:ss')}</span>
                        ),
                    }
                },
            ]}
        />
    )
}
